import { useDispatch, useSelector } from "react-redux"
import { useLocation } from "react-router-dom"
import { useEffect, useState } from "react"
import styled from "styled-components"
import { useScrollLock } from "../../hooks/useScrollLock"
import { showModal } from "../../features/modal/modalSlice"
import { handleActiveSelect } from "../../features/layout/layoutSlice"
import PageTopTitle from "../shared/PageTopTitle"
import Btn from "../shared/button/Btn"
import { UETDSNotificationDriverCalled } from "../../features/admin4/admin4Slice"
import InputSelect from "../shared/input/new/InputSelect"
import InputTextarea from "../shared/input/new/InputTextarea"



const ModalContainer = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 26;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        padding-block: 20px;
        border-radius: 10px;
        margin: 0 auto;
        .content{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;
            height: 100%;
            padding: 20px;
        }
        .input-container{
            padding: 10px 0px;
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 15px;
            justify-content: center;
            align-items: center;
        }
        .btn-container{
            width: 100%;
            display: flex;
            gap: 15px;
            justify-content: center;
            align-items: center;
        }
    }


`

const statusOptions = [
    {
      id: 1,
      text: "Arandı",
      bool: true,
    },
    {
      id: 2,
      text: "Aranmadı",
      bool: false
    }
  ]

const UetdsControlUpdateModal = () => {
    const dispatch = useDispatch()
    const location = useLocation()

    const {modalLocation } = useSelector(state => state.modal)
    const { lockScroll, unlockScroll } = useScrollLock();
    const [isDriverCalled, setIsDriverCalled] = useState(null)
    const [description, setDescription] = useState("")
    const {selectedUetdsNotification} = useSelector((state) => state.admin4)

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

    const handleSubmit = () => {
        const addData = {
            id: selectedUetdsNotification.id,
            isDriverCalled: isDriverCalled.bool,
            description: description
        }
        
        dispatch(UETDSNotificationDriverCalled(addData))
    }

    return (
    <ModalContainer onClick={()=> {dispatch(showModal(null));}}>
        <div className="modal" onClick={(e) => { e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Engellenen Sürücüler"}/>
            <div className="content">
                <div className="input-container">
                    <InputSelect data={isDriverCalled?.text} setData={setIsDriverCalled} initialOptions={statusOptions} labelText={"Sürücü Arandı Mı?"} name={"isDriverCalled"} inputWidth={"400px"} />
                    <InputTextarea data={description} setData={(e) => setDescription(e.target.value)} labelText={"Açıklama"} inputWidth={"400px"} name={"description"} />
                </div>
                <div onClick={(e) =>{ e.stopPropagation(); }} className="btn-container">
                    <Btn bgColor="#fff" width="100px"  handleClick={handleSubmit} color="#E85446">Güncelle</Btn>
                    <Btn bgColor="#fff" width="100px" handleClick={() => {dispatch(showModal(null))}} color="#E85446">Kapat</Btn>
                </div>
            </div>
            
            
        </div>
    </ModalContainer>
  )
}

export default UetdsControlUpdateModal